import { Experiment, Variant } from '@svt/abtest/lib/redux'; // A/B-test Favorites rollout sep 2021
import PlayLogo from '@ui-components/PlayLogo';
import { VisuallyHiddenStyle } from '@ui-components/utils.styles';
import { trackCustomEvent } from '@utils/statistics/clientStatistics';
import { mainMenuItemClickEvent } from '@utils/statistics/customEvents';
import ExperimentDropdown, {
    ExperimentDropdownVariant,
} from 'app/components/Header/components/MenuItem/ExperimentDropdown/ExperimentDropdown';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useCallback, useState } from 'react';
import AutoCompleteSearchFormContainer from '../../AutoCompleteSearch/AutoCompleteSearchFormContainer';
import MenuItem from '../MenuItem/MenuItem';
import { ListItem } from '../MenuItem/MenuItem.styles';
import { LogoLink, MenuItems, Navigation, SearchListItem, SearchToggle } from './Menu.styles';

export const Menu = (props) => {
    const router = useRouter();
    const [activeMobileSearch, setActiveMobileSearch] = useState(false);

    const onMobileSearchClick = useCallback(() => {
        setActiveMobileSearch(!activeMobileSearch);
    }, [activeMobileSearch]);

    const onMobileSearchKeyDown = useCallback(
        (e) => {
            if (e.which === 13 || e.which === 32) {
                e.preventDefault();
                setActiveMobileSearch(!activeMobileSearch);
            }
        },
        [activeMobileSearch]
    );

    return (
        <Navigation aria-label="topp-navigation" data-rt="play-navigation">
            <Link href="/" passHref>
                <LogoLink
                    data-rt-spec="play-logo"
                    onClick={() => {
                        trackCustomEvent(mainMenuItemClickEvent('Logo', 1));
                    }}
                >
                    <PlayLogo />
                </LogoLink>
            </Link>

            <MenuItems className="lp_nav">
                <MenuItem
                    route="/"
                    accessKey="1"
                    text="Start"
                    type="start"
                    index={2}
                    currentPath={router.pathname}
                />
                <Experiment projectId="svtplay" slug="header-test-3" defaultVariant="original">
                    <Variant slug="original">
                        <MenuItem
                            route="/program"
                            accessKey="2"
                            text="Program"
                            type="programs"
                            index={3}
                            currentPath={router.pathname}
                        />
                    </Variant>
                    <Variant slug="top-categories">
                        <ListItem type="programs" data-rt="menu-item">
                            <ExperimentDropdown />
                        </ListItem>
                    </Variant>
                    <Variant slug="top-categories-and-sticky">
                        <ListItem type="programs" data-rt="menu-item">
                            <ExperimentDropdown />
                        </ListItem>
                    </Variant>
                    <Variant slug="all-categories-editorial">
                        <ListItem type="programs" data-rt="menu-item">
                            <ExperimentDropdown variant={ExperimentDropdownVariant.ALL_EDITORIAL} />
                        </ListItem>
                    </Variant>
                    <Variant slug="all-categories-alphabetic">
                        <ListItem type="programs" data-rt="menu-item">
                            <ExperimentDropdown variant={ExperimentDropdownVariant.ALL_ABC} />
                        </ListItem>
                    </Variant>
                </Experiment>
                <MenuItem
                    route="/kanaler"
                    accessKey="3"
                    text="Kanaler"
                    type="channels"
                    index={4}
                    currentPath={router.pathname}
                />
                <ListItem type="search">
                    <input
                        hidden
                        type="checkbox"
                        id="search-mobile-toggle"
                        name="search-mobile-toggle"
                        onChange={onMobileSearchClick}
                    />
                    <SearchToggle
                        tabIndex={0}
                        htmlFor="search-mobile-toggle"
                        onKeyDown={onMobileSearchKeyDown}
                        aria-label="Visa sökfältet"
                    >
                        <span aria-hidden="true">Sök</span>
                        <VisuallyHiddenStyle>
                            {activeMobileSearch ? 'Dölj sökfältet' : 'Visa sökfältet'}
                        </VisuallyHiddenStyle>
                    </SearchToggle>
                </ListItem>
                <SearchListItem hiddenXs={!activeMobileSearch}>
                    <AutoCompleteSearchFormContainer
                        // eslint-disable-next-line react/jsx-props-no-spreading
                        {...props}
                        activeMobileSearch={activeMobileSearch}
                    />
                </SearchListItem>
            </MenuItems>
        </Navigation>
    );
};

export default Menu;
